import { render } from "./CoinFavModal.vue?vue&type=template&id=0eeb076c&scoped=true"
import script from "./CoinFavModal.vue?vue&type=script&lang=js"
export * from "./CoinFavModal.vue?vue&type=script&lang=js"

import "./CoinFavModal.vue?vue&type=style&index=0&id=0eeb076c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eeb076c"]])

export default __exports__